import { render, staticRenderFns } from "./Original.vue?vue&type=template&id=4914d38a"
import script from "./Original.vue?vue&type=script&lang=js"
export * from "./Original.vue?vue&type=script&lang=js"
import style0 from "./Original.vue?vue&type=style&index=0&id=4914d38a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports